var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bg-gray-100 frc rounded-sm px-2 py-1",class:[_vm.bgColor]},[_c('span',{staticClass:"text-gray-500 whitespace-nowrap text-sm",class:[_vm.textColor]},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }